/**
 * TrackedPhoneLink · `<a href="tel:...">` mit Anruf-Tracking.
 *
 * Das eigentliche Tracking (phone_click → Google Ads + Meta + dataLayer)
 * übernimmt seit dem zentralen Klick-Listener lib/clickTracking.js –
 * diese Komponente liefert nur noch den Link + die Quelle als data-Attribut.
 * (Kein eigenes gtag-Event mehr, sonst würde doppelt gezählt.)
 *
 * Props:
 *   source · String — Wo wurde geklickt? (LP-Slug, „header", „footer", …)
 *   tel    · String — Telefonnummer (Default = Hauptnummer)
 */
export default function TrackedPhoneLink({
  source = "unknown",
  value = 15,
  tel = "+4921129273330",
  onClick,
  children,
  ...rest
}) {
  return (
    <a href={`tel:${tel}`} data-track-source={source} onClick={onClick} {...rest}>
      {children}
    </a>
  );
}
